import {Component} from "react";
import {withRouter} from 'react-router-dom';

class ScrollToTop extends Component {

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const obj = document.querySelector('.app');
      obj.scrollIntoView(true);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop)


// WEBPACK FOOTER //
// ./src/components/App/ScrollToTop.js